import axios from 'axios';
import { CustomAxiosRequestConfig } from '../interfaces/axiosInterfaces';

// TODO: check GitHub issue before upgrading to latest axios package.
// https://github.com/axios/axios/issues/2295
// They also added a Method type for the method that we can use when we upgrade
const ApiService = {
    /**
     * Makes a POST call through axios
     * @param url URL of the API to call
     * @param postBody JSON body of the POST API call
     * @param useBearerToken indicator of whether the bearer token needs to be added to the api call, defaults to false
     * @param isInterceptorEnabled indicator of whether the axios interceptor logic should run, defaults to true - should only be false for auth calls
     */
    async post(url: string, postBody: any, useBearerToken: boolean = false, isInterceptorEnabled: boolean = true): Promise<any> {
        const response = await axios({
            url,
            method: 'POST',
            data: postBody,
            useBearerToken,
            isInterceptorEnabled
        } as CustomAxiosRequestConfig);

        return response.data;
    },
    /**
     * Makes a PUT call through axios
     * @param url URL of the API to call
     * @param postBody JSON body of the POST API call
     * @param useBearerToken indicator of whether the bearer token needs to be added to the api call, defaults to false
     * @param isInterceptorEnabled indicator of whether the axios interceptor logic should run, defaults to true - should only be false for auth calls
     */
    async put(url: string, postBody: any, useBearerToken: boolean = false, isInterceptorEnabled: boolean = true): Promise<any> {
        const response = await axios({
            url,
            method: 'PUT',
            data: postBody,
            useBearerToken,
            isInterceptorEnabled
        } as CustomAxiosRequestConfig);

        return response.data;
    },

    /**
     * Makes a GET call through axios
     * @param url URL of the API to call
     * @param useBearerToken indicator of whether the bearer token needs to be added to the api call, defaults to false
     * @param isInterceptorEnabled indicator of whether the axios interceptor logic should run, defaults to true - should only be false for auth calls
     */
    async get(url: string, useBearerToken: boolean = false, isInterceptorEnabled: boolean = true): Promise<any> {
        const response = await axios({
            url,
            method: 'GET',
            useBearerToken,
            isInterceptorEnabled
        } as CustomAxiosRequestConfig);

        return response.data;
    },

    async getBlob(url: string, useBearerToken: boolean = false, isInterceptorEnabled: boolean = true): Promise<any> {
        const response = await axios({
            url,
            method: 'GET',
            useBearerToken,
            isInterceptorEnabled,
            responseType: 'blob'
        } as CustomAxiosRequestConfig);

        return response.data;
    },

    /**
     * Makes a DELETE call through axios
     * @param url URL of the API to call
     * @param useBearerToken indicator of whether the bearer token needs to be added to the api call, defaults to false
     * @param isInterceptorEnabled indicator of whether the axios interceptor logic should run, defaults to true - should only be false for auth calls
     */
    async delete(url: string, useBearerToken: boolean = false, isInterceptorEnabled: boolean = true): Promise<any> {
        const response = await axios({
            url,
            method: 'DELETE',
            useBearerToken,
            isInterceptorEnabled
        } as CustomAxiosRequestConfig);

        return response.data;
    }
};

export default ApiService;
